import Tools from './../components/tools';

export default class Trombinoscope {
  constructor() {
    // Archive Trombinoscope
    this.manageSubCategories();
  }

  manageSubCategories() {
    const subCategories = document.querySelectorAll('section.content .trombinoscope-container .sous-categories li');
    if (subCategories.length > 0) {
      subCategories.forEach((category) => {
        category.addEventListener('click', () => {
          if (document.querySelector('section.content .trombinoscope-container .sous-categories li.active')) {
            document.querySelector('section.content .trombinoscope-container .sous-categories li.active').classList.remove('active');
          }
          category.classList.add('active');
          document.querySelector('section.content .trombinoscope-container .personnes.active').classList.remove('active');
          document.querySelector(`section.content .trombinoscope-container .personnes[data-tab="${category.dataset.id}"]`).classList.add('active');
        });
      });
    }
  }
}